export enum FilteringPeriodTypeEnum {
  INDEXATION = 'indexation_period',
  ESTIMATED_END = 'estimated_end_period',
  PUBLICATION = 'period',
}

export interface Period {
  from: string;
  to: string;
}
